/**
 * Este componente exibe uma tela informando ao usuário que sua conta já está vinculada
 * ao profissional que enviou o convite. Geralmente é exibido quando um usuário tenta
 * aceitar um convite de um profissional com o qual ele já tem vínculo.
 */
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import H1 from "../../../../../components/UI/Titles/H1/h1";
import RoundedButton from "../../../../../components/Buttons/RoundedButton";
import StateView from '../shared/StateView';
import LinkMessage from '../shared/LinkMessage';
import StateIcon from '../shared/StateIcon';
import classes from '../../RescueCode.module.scss';
/**
 * Componente que renderiza a tela de "Já está vinculado"
 * 
 * @component
 * @param {Object} props - Propriedades do componente
 * @param {string} props.inviterName - Nome do profissional que enviou o convite
 * @param {Function} props.redirectToDashboard - Função para redirecionar o usuário para o painel principal
 * @returns {JSX.Element} Tela informando que o usuário já está vinculado ao profissional
 */
const AlreadyLinkedView = ({ inviterName, redirectToDashboard }) => {
  return (
    // Container principal do componente com estilo específico
    <StateView className={classes.alreadyLinkedContainer}>
      {/* Título principal da tela */}
      <H1 className={classes.alreadyLinkedTitle}>Você já está vinculado!</H1>

      {/* Mensagem explicativa para o usuário */}
      <LinkMessage className={classes.alreadyLinkedMessage}>
        <p>Seu perfil já está vinculado à <strong>{inviterName}</strong>.</p>
        <p>Não é necessário aceitar este convite novamente.</p>
      </LinkMessage>

      {/* Ícone de confirmação (círculo com check) */}
      <StateIcon 
        icon={faCheckCircle} // Ícone de check em círculo da biblioteca FontAwesome
        iconContainerClass={classes.alreadyLinkedIconContainer} // Classe para o container do ícone
        iconClass={classes.alreadyLinkedIcon} // Classe para o ícone em si
      />

      {/* Botão para retornar ao painel principal */}
      <RoundedButton
        className={classes.returnButton}
        text="VOLTAR AO PAINEL" // Texto exibido no botão
        onClick={redirectToDashboard} // Função chamada ao clicar no botão
      />
    </StateView>
  );
};

export default AlreadyLinkedView;